import $ from 'jquery';
import { RouteParams } from 'universal-router';
import { Page } from '../Page';
import { tns } from 'tiny-slider';

export class BlogPage extends Page {
    public static render(params: RouteParams): void {
        BlogPage._initTinySlider();
    }

    private static _initTinySlider(): void {
        const slider = $('body .tns-slider__blog');
        if (slider.length == 0) {
            return;
        }
        tns({
            loop: true,
            container: slider.get(0),
            items: 1,
            nav: false,
            controls: false,
            mouseDrag: true,
            autoplay: true,
            autoplayButtonOutput: false,
            controlsContainer: false
        });
    }
}
